// main.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { AuthProvider } from "./context/AuthContext";
import { ApplicationProvider } from "./context/ApplicationContext";
import { PaymentProvider } from "./context/PaymentContext";
import { LanguageProvider } from "./context/LanguageContext";
import { SearchProvider } from "./context/SearchContext";
import MobileWrapper from "./components/MobileWrapper";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import {HelmetProvider} from "react-helmet-async";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
    <AuthProvider>
      <MobileWrapper>
        <SearchProvider>
          <LanguageProvider>
            <ApplicationProvider>
              <PaymentProvider>
                <App />
                <Analytics />
                <SpeedInsights />
              </PaymentProvider>
            </ApplicationProvider>
          </LanguageProvider>
        </SearchProvider>
      </MobileWrapper>
    </AuthProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
